<template>
  <section class="success">
    <popup-base
      v-show="wantToMakeOffer"
      class="popo md:pt-10 md:pb-4 w-full"
      @clickOnBackground="logState"
    >
      <div class="cardinal mr-auto ml-auto p-5">
        <div
          class="success-container h-full pt-6 p-6 pb-12"
        >
          <div class="text-left flex pl-6 pr-6">
            <div class="w-full flex justify-end">
              <icon
                :data="icons.fermer"
                height="30"
                width="30"
                class="cursor-pointer"
                original
                @click="fermer"
              />
            </div>
          </div>

          <div class="text-c18 font-c4 bg-white flex text-left">
            <img
              v-if="type === 'Verre'"
              src="../../assets/images/jpg/lunette.jpg"
              alt=""
              class="img"
            >
            <img
              v-if="type === 'Accessoire'"
              src="../../assets/images/jpg/etuie.jpg"
              alt=""
              class="img"
            >
            <img
              v-if="type === 'Monture'"
              src="../../assets/images/jpg/lunette.jpg"
              alt=""
              class="img"
            >
            <div class="w-2/3 ml-6">
              <div class="text-90 font-c6 text-c16">
                {{ type }}
              </div>
              <div class="text-c42 font-c6">
                {{ donnes.name.substr(0, 38) }} <span v-if="donnes.name.length > 38">..</span>
              </div>

              <div class="flex text-c14 mt-10" v-if="type !== 'Verre'">
                <div>Marque: </div>
                <div class="ml-2 font-c6">
                  {{ donnes.brands[0].label }}
                </div>

                <div class="ml-12">
                  Gamme:
                </div>
                <div class="ml-2 font-c6">
                  {{ donnes.ranges[0].label }}
                </div>
              </div>

              <div class="flex mt-6">
                <div
                    v-for="(item, index) in donnes.prices"
                    :key="index"
                    class="flex text-c14 mr-4"
                >
                  <div>{{ item.category.label }}:</div>
                  <div class="ml-2 font-c6 text-orange">
                    {{ item.amount.toLocaleString() }} Frs
                  </div>
                </div>

                <div
                    v-if="donnes.prices.length === 0"
                    class="text-c14 text-90"
                >
                  Aucun prix n'a été ajouté pour ce produit
                </div>

              </div>

              <div class="flex text-c14 mt-6">
                <div>Qté dispo: </div>
                <div class="ml-2 text-oho-green">
                  {{ donnes.quantity.toLocaleString() }}
                </div>
              </div>

              <div
                  v-if="type !== 'Verre' && donnes.accessories !== null"
                  class="flex mt-6"
              >
                <div class="w-1/4 mr-3">
                  <div class="text-c15 font-c6">Etuis</div>
                  <img src="../../assets/images/jpg/etuie.jpg" alt="" class="access mt-2">
                </div>

                <div class="w-1/4">
                  <div class="text-c15 font-c6">Essuie</div>
                  <img src="../../assets/images/jpg/essui.jpg" alt="" class="access mt-2">
                </div>
              </div>

              <div class="mt-6 text-c14 text-90" v-if="donnes.accessories === null"> Aucun accessoires supplémentaire </div>
            </div>
          </div>

          <div class="diviser mt-6"/>

          <div class="mt-6 text-left">
            <div class="text-c16 ">Ventillation de stock</div>

            <div class="text-c16 flex mt-4 text-90">
              <div class="w-5/6">Stock</div>
              <div class="w-1/6 text-right">Qté</div>
            </div>
          </div>

          <div class="text-left">
            <div class="text-c16 flex mt-2">
              <div class="w-5/6">Stock principal</div>
              <div class="w-1/6 text-right"> {{ donnes.quantity.toLocaleString() }} </div>
            </div>
          </div>
        </div>
      </div>
    </popup-base>
  </section>
</template>

<script>
import PopupBase from '../helper/add/popupfat'
import ic_agence from '../../assets/icons/agenceGray.svg'
import fermer from '../../assets/icons/fermer.svg'

export default {
  name: 'Success',
  components: { PopupBase },
  props: {
    activation: {
      type: Boolean,
      default: false
    },
    donnes: {
      type: Object,
      default: null
    },
    type: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      wantToMakeOffer: false,
      icons: {
        ic_agence,
        fermer
      },
      prix: '',
      nom: '',
      qte: '',
      error: null,
      charge: false,
      file: null
    }
  },

  created() {
    this.wantToMakeOffer = this.activation
  },

  methods: {
    fermer () {
      this.$emit('oga', false)
    },

    continuer (answer) {
      this.charge = true
      this.error = null
      if (this.nom.length > 0 && this.qte.length > 0 && this.prix.length > 0 && this.file !== null) {
        this.$emit('oga', false)
        this.charge = false
      } else {
        this.charge = false
        this.error = 'Veuillez remplir les champs pour continuer'
      }
    },

    retourFile (answer) {
      this.file = answer
    },

    logState (answer) {
      this.wantToMakeOffer = answer
      this.$emit('oga', false)
    },

    retourAccessoire (answer) {
      this.valueAccessoire = answer
    },

    retourNom (answer) {
      this.nom = answer
    },

    retourQte (answer) {
      this.qte = answer
    },

    retourPrix (answer) {
      this.prix = answer
    }
  }
}
</script>

<style lang="scss"  scoped>
    @import "../../assets/styles/sass/mixin";
    .success {
      z-index: 999;
    }
    .cardinal {
      width: 80%;
    }

    .access {
      width: 145.38px;
      height: 68.41px;
      object-fit: cover;
      border-radius: 6px;
    }
    .img {
      width: 312.98px;
      height: 340.35px;
      object-fit: cover;
    }
    .diviser {
      height: 1px;
      background-color: #DDDDDD;
    }

    .success-container {
      font-family: $font-default;
      width: 100%;
      background-color: white;
      height: auto;
      margin: auto;
      border-radius: 12px;
    }
    @media screen and (max-width: 700px){
      .success-container {
        width: 100%;
        height: 100vh;
      }
      .titre {
        font-size: 18px;
      }
      .bloc1 {
        width: 100%;
      }
      .bloc2 {
        width: 100%;
        font-size: 18px;
      }
      .button {
        width: 100%;
        font-size: 16px;
      }
      .cardinal {
        width: 100%;
      }
    }

    @media screen and (max-width: 1024px) and (min-width: 770px){
      .cardinal{
        width: 65%;
      }
      .titre{
        font-size: 18px;
      }
      .button{
        width: 100%;
        height: 55px;
        font-size: 19px;
      }
    }

    @media screen and (max-width: 769px) and (min-width: 701px){
      .cardinal{
        width: 90%;
      }
      .titre{
        font-size: 18px;
      }
      .button{
        width: 100%;
        height: 55px;
        font-size: 19px;
      }
    }
    @media screen and (max-width: 320px){
      .cardinal{
        width: 100%;
      }
      .titre{
        font-size: 14px;
      }
      .button{
        width: 100%;
        height: 55px;
        font-size: 15px;
      }
    }
</style>
